import { formatNumber } from "shared/locale/format";
import { isNumeric } from "shared/utils";

import { X_AXIS_FONT_COLOR } from "pages/shared/Dashboard/constants";

interface CustomYAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: string | number };
}

const CustomYAxisTick = ({ x = 0, y = 0, payload }: CustomYAxisTickProps) => {
  const tickWidth = 8; // Total width of the tick line
  const startX = x - tickWidth;
  const endX = x;

  // define the curve path
  const q1End = startX + tickWidth * 0.25;
  const q2End = startX + tickWidth * 0.75;

  const curveHeight = 4; // distance to curve up

  const pathData = `
    M ${startX} ${y + curveHeight}
    L ${q1End} ${y + curveHeight}
    C ${q1End + (q2End - q1End) * 0.3} ${y + curveHeight},
      ${q1End + (q2End - q1End) * 0.7} ${y},
      ${q2End} ${y}
    L ${endX} ${y}
  `;

  const displayValue = isNumeric(payload?.value)
    ? formatNumber(Number(payload?.value), 0)
    : payload?.value;

  return (
    <g>
      <path d={pathData} stroke="#A8A8A8" strokeWidth="1" fill="none" />
      <text
        x={x - tickWidth - 2}
        y={y + 7}
        textAnchor="end"
        fontSize={10}
        fill={X_AXIS_FONT_COLOR}
      >
        {displayValue}
      </text>
    </g>
  );
};

export default CustomYAxisTick;
